import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_STOCK_FUNDAMENTAL_DETAIL_API_ID =
  'DASHBOARD/FETCH_STOCK_FUNDAMENTAL_DETAIL_API_ID';

const apiCall = createApiCall(
  FETCH_STOCK_FUNDAMENTAL_DETAIL_API_ID,
  ({ id, ...params }: { id: string; params: any }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/stock-fundamentals/${id}`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
